import { useEffect } from 'react'
import { gql, useSubscription } from '@apollo/client'

import { INRWorkoutSessionHit } from 'interfaces/workout'
import { useWorkoutActions } from 'store/workout/selectors'

const HIT = gql`
  subscription addHit {
    hit {
      force
      angle
      height
      punchedAt
    }
  }
`

interface UseAddHitOptions {
  shouldAcceptHit?: (hit: INRWorkoutSessionHit) => boolean
}

const useAddHit = ({ shouldAcceptHit }: UseAddHitOptions = {}) => {
  const { data } = useSubscription<{ hit: INRWorkoutSessionHit }>(HIT)
  const { addHit } = useWorkoutActions()

  useEffect(() => {
    if (data?.hit) {
      if (shouldAcceptHit && !shouldAcceptHit(data.hit)) return
      addHit(data.hit)
    }
  }, [data, addHit, shouldAcceptHit])
}

export default useAddHit
